import api from '@/utils/api'
import { buildListQuery } from '@/utils/listQuery'

export default {
    // the requests every team agreed on (to decide) and the declined / expired ones not seen yet
    getMatchChangeNotifications() {
        return api.get(`match-changes/notifications`)
    },

    getFilteredMatchChanges(filter, page, size, sort) {
        return api.get(`match-changes` + buildListQuery({ filter, page, size, sort }))
    },

    // swaps the slots (date, time and arena) of the two matches and notifies the followers of their teams
    approveMatchChange(id) {
        return api.post(`match-changes/${id}/approve`)
    },

    rejectMatchChange(id) {
        return api.post(`match-changes/${id}/reject`)
    },

    // a declined / expired request leaves the notifications
    markMatchChangeSeen(id) {
        return api.post(`match-changes/${id}/seen`)
    }
}
